import * as React from "react"
import { Typography, Box, Link } from "@mui/material"
import { CardSeeker, IconSeeker } from "@ui-seeker/core"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"
import { GROUPED_BY, WEBBACK_V2_API } from "@constants"
import { SkuDetailsLabelCountry } from "./@components"
import SkuDetailsDistributionCarousel from "./DistributionCarousel"


export default function SkuDetailsDistributionData({ distributionData, tabSelected }) {
    const data = distributionData[tabSelected]
    return <SkuDetailsDistributionCarousel>
        { data.map((item, idx) => {
            return <CustomComponent item={item} key={idx} tabSelected={tabSelected} />
        })}
    </SkuDetailsDistributionCarousel>
}

function CustomComponent({ item, idx, tabSelected }) {
    const sxFake = !item?.isFake ? {} : { backgroundColor: 'error.lighter', borderColor: 'red', borderWidth: 1, borderStyle: 'solid' }
    return <CardSeeker key={idx} sx={sxFake}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold' }}>

                {tabSelected === GROUPED_BY.COUNTRY && <LabelCountry country={item.country} label={translateCountryName(item.country)} />}

                {(tabSelected === GROUPED_BY.RETAILER || tabSelected === GROUPED_BY.MARKETPLACE) && 
                    (!!item?.isFake ? (
                        <SkuDetailsLabelCountry country={item.country} label={item.label} sx={{ mr: 1 }} />
                    ) : (
                        <Link href={`${WEBBACK_V2_API}/sku-details/product-url/sku/${item.id_site}/${item.skuID}`} target="_blank" sx={{ display: 'flex', alignItems: 'center', color: 'inherit'}}>
                            <SkuDetailsLabelCountry country={item.country} label={item.label} sx={{ mr: 1 }} />
                            <IconSeeker icon={'arrow-up-right-from-square'} sx={{ fontSize: '0.8rem', mr: 0.5, margin: .3, color: 'primary.main'}}/>
                        </Link>
                    ))
                }

                {tabSelected === GROUPED_BY.SELLER && item}
            </Typography>
        </Box>
    </CardSeeker>
}